export function authHeader() {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem("okta-token-storage"));

  if (user && user.accessToken && user.accessToken.accessToken) {
    return { Authorization: `Bearer ${user.accessToken.accessToken}` };
  } else {
    return null;
  }
}
